/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

(() => {
  const CHALLENGE_SELECTOR = '#challenge, .shopify-challenge__container';
  const DEFAULT_ERROR_MESSAGE = 'Er ging iets mis. Probeer het opnieuw.';
  const CHALLENGE_ERROR_MESSAGE = 'Beveiligingscontrole actief. Ververs de pagina en probeer opnieuw.';
  const NEWSLETTER_SUBSCRIBED_COOKIE = 'newsletter_subscribed';
  const NEWSLETTER_SUBSCRIBED_COOKIE_DAYS = 3650;
  const SHOPIFY_INLINE_FORM_SELECTOR = '[data-form-root="true"]';
  const SHOPIFY_INLINE_FORM_STYLE_ID = 'mrstarsky-inline-form-style';
  const SHOPIFY_FORMS_NEWSLETTER_ROOT_ID = 'forms-root-964502';
  const SHOPIFY_FORMS_NEWSLETTER_EVENT = 'lead_submitted';
  const SHOPIFY_FORMS_SUCCESS_WATCH_TIMEOUT = 30 * 60 * 1000;
  const SHOPIFY_FORMS_EMBED_WAIT_INTERVAL = 250;
  const SHOPIFY_FORMS_EMBED_WAIT_ATTEMPTS = 120;
  const LAZY_IMAGE_WAKE_SELECTOR = 'img[loading="lazy"]';
  const LAZY_IMAGE_WAKE_MARGIN = 900;
  const TRUSTPILOT_WIDGET_SELECTOR = '.trustpilot-widget';
  const TRUSTPILOT_SCRIPT_SELECTOR = 'script[data-mrstarsky-trustpilot-script]';
  const TRUSTPILOT_SCRIPT_URL = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  const ORBE_MODAL_SELECTOR = '#md-app-embed__modal';
  const ORBE_EMBED_SELECTOR = '.md-app-embed';
  const ORBE_FORCE_HIDE_ATTRIBUTE = 'data-mrstarsky-force-hidden';
  const LAZY_IMAGE_WAKE_EVENTS = [
    'DOMContentLoaded',
    'load',
    'resize',
    'orientationchange',
    'scroll',
    'on:media-carousel:init',
    'on:media-carousel:slide-change',
    'on:media-carousel:slide-transition-end',
    'on:cart:loaded',
    'on:cart:loading',
    'on:cart-recommendations:updated',
    'on:modal:opened',
    'on:popup:opened',
  ];
  const SHOPIFY_INLINE_FORM_ARROW =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 12h14'/%3E%3Cpath d='m12 5 7 7-7 7'/%3E%3C/svg%3E\")";
  const SHOPIFY_INLINE_FORM_SHADOW_CSS = `
    :host {
      display: block;
      width: 100%;
      max-width: 760px;
      margin: 0 auto;
      color: #212121;
      font-family: 'Open Sans', sans-serif;
    }

    *, *::before, *::after {
      box-sizing: border-box;
    }

    h1, h2, h3 {
      color: #212121 !important;
      font-family: 'Open Sans', sans-serif !important;
      font-weight: 700 !important;
      line-height: 1.08 !important;
      letter-spacing: 0 !important;
      text-align: center !important;
      margin: 0 0 12px !important;
    }

    h1 {
      font-size: clamp(2rem, 3.7vw, 3.25rem) !important;
    }

    h2, h3 {
      font-size: clamp(1.85rem, 3.2vw, 2.8rem) !important;
    }

    p, label, legend, span, small, li {
      color: #212121 !important;
      font-family: 'Open Sans', sans-serif !important;
      line-height: 1.45 !important;
    }

    a {
      color: #212121 !important;
    }

    form {
      display: flex !important;
      flex-wrap: wrap !important;
      justify-content: center !important;
      align-items: flex-start !important;
      gap: 16px !important;
      width: 100% !important;
      margin-top: 24px !important;
    }

    form > * {
      flex: 0 0 100% !important;
      width: 100% !important;
    }

    .mrstarsky-form-field {
      flex: 1 1 260px !important;
      min-width: 0 !important;
    }

    .mrstarsky-form-submit {
      flex: 0 0 280px !important;
      width: 280px !important;
    }

    .mrstarsky-form-consent,
    .mrstarsky-form-feedback {
      flex: 0 0 100% !important;
      width: 100% !important;
    }

    input:not([type='checkbox']):not([type='radio']),
    select,
    textarea {
      width: 100% !important;
      min-height: 54px !important;
      padding: 14px 18px !important;
      border: 0 !important;
      border-radius: 14px !important;
      background: #ffffff !important;
      box-shadow: none !important;
      color: #212121 !important;
    }

    input::placeholder,
    textarea::placeholder {
      color: rgba(33, 33, 33, 0.55) !important;
    }

    input[type='checkbox'],
    input[type='radio'] {
      accent-color: #d19371 !important;
    }

    button[type='submit'] {
      width: 100% !important;
      min-height: 54px !important;
      padding: 14px 28px !important;
      border: 0 !important;
      border-radius: 999px !important;
      background: #e4c1b2 !important;
      color: #000 !important;
      box-shadow: none !important;
      font-family: 'Open Sans', sans-serif !important;
      font-weight: 700 !important;
      line-height: 1 !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 12px !important;
      transition: background-color 0.2s ease !important;
    }

    button[type='submit']::after {
      content: '' !important;
      display: inline-block !important;
      width: 1.2rem !important;
      height: 1.2rem !important;
      min-width: 1.2rem !important;
      min-height: 1.2rem !important;
      flex-shrink: 0 !important;
      background-image: ${SHOPIFY_INLINE_FORM_ARROW} !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
      background-size: contain !important;
    }

    button[type='submit']:hover,
    button[type='submit']:focus-visible {
      background: #ddb8aa !important;
    }

    @media (max-width: 767px) {
      form {
        display: block !important;
        margin-top: 20px !important;
      }

      .mrstarsky-form-field,
      .mrstarsky-form-submit,
      .mrstarsky-form-consent,
      .mrstarsky-form-feedback {
        width: 100% !important;
      }

      .mrstarsky-form-field,
      .mrstarsky-form-consent,
      .mrstarsky-form-submit {
        margin-bottom: 12px !important;
      }
    }
  `;

  const AJAX_NEWSLETTER_CONFIGS = [
    {
      formSelector: '.section-newsletter .newsletter__form-form',
      wrapperSelector: '.newsletter__form-wrapper',
      successSelector: '.newsletter__form-message',
      inputSelector: '.newsletter__input',
      successHash: 'newsletter',
      successQueryParam: 'customer_posted',
      successQueryValue: 'true',
      scrollTargetSelector: '.section-newsletter',
    },
    {
      formSelector: '.promo-pop__form-form',
      wrapperSelector: '.promo-pop__form',
      replaceSelector: '.promo-pop__content',
      successSelector: '.promo-pop__form-message',
      inputSelector: '.promo-pop__input',
    },
  ];

  const getFormConfig = (form) =>
    AJAX_NEWSLETTER_CONFIGS.find((config) => form.matches(config.formSelector)) ?? null;

  const isChallengeResponse = (nextDocument, html = '') => {
    if (!nextDocument) return false;

    if (nextDocument.querySelector(CHALLENGE_SELECTOR)) return true;
    if (nextDocument.querySelector('iframe[src*="hcaptcha"], script[src*="hcaptcha"]')) return true;
    if (nextDocument.querySelector('form[action*="/challenge"]')) return true;

    const bodyClass = nextDocument.body?.className || '';
    if (bodyClass.includes('challenge')) return true;

    return /hcaptcha|recaptcha|shopify[-_ ]challenge/i.test(html);
  };

  const submitFormNatively = (form) => {
    if (!form || form.dataset.nativeSubmitting === 'true') return;
    form.dataset.nativeSubmitting = 'true';
    form.submit();
  };

  const updateUrlForSuccess = (config) => {
    if (!config) return;

    const nextUrl = new URL(window.location.href);

    if (config.successQueryParam) {
      nextUrl.searchParams.set(config.successQueryParam, config.successQueryValue || 'true');
    }

    if (config.successHash) {
      nextUrl.hash = config.successHash;
    }

    history.replaceState(window.history.state, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
  };

  const scrollToSuccessTarget = (currentForm, wrapper, config) => {
    if (!config?.scrollTargetSelector) return;

    const target =
      currentForm.closest(config.scrollTargetSelector) ||
      wrapper.closest(config.scrollTargetSelector) ||
      document.querySelector(config.scrollTargetSelector);

    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const setNewsletterSubscribedCookie = () => {
    const expiresDate = new Date(Date.now() + NEWSLETTER_SUBSCRIBED_COOKIE_DAYS * 24 * 60 * 60 * 1000);
    const secureFlag = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${NEWSLETTER_SUBSCRIBED_COOKIE}=1; expires=${expiresDate.toUTCString()}; path=/; SameSite=Lax${secureFlag}`;
  };

  const syncSubscriptionCookieFromDOM = (root = document) => {
    if (root.querySelector('.newsletter__form-message, .promo-pop__form-message')) {
      setNewsletterSubscribedCookie();
    }
  };

  const isElementNearViewport = (element, margin = LAZY_IMAGE_WAKE_MARGIN) => {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    return (
      rect.bottom >= -margin &&
      rect.right >= -margin &&
      rect.top <= viewportHeight + margin &&
      rect.left <= viewportWidth + margin
    );
  };

  const wakeLazyImage = (image) => {
    if (!image || image.dataset.lazyWakeDone === 'true') return;
    if (!isElementNearViewport(image)) return;

    image.dataset.lazyWakeDone = 'true';
    image.loading = 'eager';

    if ('fetchPriority' in image && image.getAttribute('fetchpriority') !== 'high') {
      image.fetchPriority = 'auto';
    }

    // Some mobile browsers need a layout turn after carousels/header resize before
    // they commit lazy image requests near the new viewport.
    requestAnimationFrame(() => {
      if (!image.complete && image.currentSrc) {
        image.src = image.currentSrc;
      }
    });
  };

  const revealResolvedImageSkeleton = (image) => {
    if (!image?.complete && !image?.classList?.contains('product-card__img--loaded')) return;

    const skeleton =
      image.previousElementSibling?.tagName?.toLowerCase() === 'image-skeleton' ? image.previousElementSibling : null;

    if (!skeleton || skeleton.hasAttribute('loaded')) return;

    if (typeof skeleton.markAsLoaded === 'function') {
      skeleton.markAsLoaded();
    } else {
      skeleton.setAttribute('loaded', '');
      skeleton.setAttribute('aria-hidden', 'true');
    }
  };

  const wakeNearbyLazyImages = (root = document) => {
    root.querySelectorAll(LAZY_IMAGE_WAKE_SELECTOR).forEach(wakeLazyImage);
    root.querySelectorAll('image-skeleton + img').forEach(revealResolvedImageSkeleton);
  };

  const scheduleLazyImageWake = (() => {
    let frame = 0;

    return (root = document) => {
      if (frame) cancelAnimationFrame(frame);

      frame = requestAnimationFrame(() => {
        frame = 0;
        wakeNearbyLazyImages(root);
      });
    };
  })();

  const initLazyImageWakeups = () => {
    LAZY_IMAGE_WAKE_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, () => scheduleLazyImageWake(), { passive: true });
      document.addEventListener(eventName, () => scheduleLazyImageWake(), { passive: true });
    });

    const headerContainer = document.querySelector('header-container');
    if (headerContainer && 'ResizeObserver' in window) {
      new ResizeObserver(() => scheduleLazyImageWake()).observe(headerContainer);
    }

    if ('MutationObserver' in window && document.body) {
      new MutationObserver((mutations) => {
        const hasImageChanges = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;
            return node.matches?.('img, image-skeleton') || node.querySelector?.('img, image-skeleton');
          }),
        );

        if (hasImageChanges) scheduleLazyImageWake();
      }).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    scheduleLazyImageWake();
    window.setTimeout(() => scheduleLazyImageWake(), 500);
    window.setTimeout(() => scheduleLazyImageWake(), 1500);
  };

  const setDynamicSectionState = (root = document) => {
    root.querySelectorAll('.section-newsletter').forEach((section) => {
      const content = section.querySelector('.newsletter__content');
      if (!content) return;

      const hasSuccessMessage = Boolean(section.querySelector('.newsletter__form-message'));
      content.classList.toggle('newsletter__content--submitted', hasSuccessMessage);
    });
  };

  const decorateFeedback = (container) => {
    if (!container) return;

    if (container.classList && container.classList.contains('errors')) {
      container.classList.add('newsletter-feedback', 'newsletter-feedback--error');
    }

    container.querySelectorAll('.errors').forEach((errors) => {
      errors.classList.add('newsletter-feedback', 'newsletter-feedback--error');
    });

    container
      .querySelectorAll('.newsletter__form-message, .promo-pop__form-message')
      .forEach((message) => {
        message.classList.add('newsletter-feedback', 'newsletter-feedback--success');
      });
  };

  const showInlineError = (wrapper, message) => {
    if (!wrapper) return;

    let errorContainer = wrapper.querySelector('.errors');
    if (!errorContainer) {
      errorContainer = document.createElement('div');
      errorContainer.className = 'errors';
      wrapper.prepend(errorContainer);
    }

    errorContainer.innerHTML = `<ul><li>${message}</li></ul>`;
    decorateFeedback(errorContainer);
    errorContainer.setAttribute('tabindex', '-1');
    errorContainer.focus();
  };

  const attachInputFocusAssist = (form, config) => {
    const inputSelector = config.inputSelector || 'input[type="email"]';
    const emailInput = form.querySelector(inputSelector);
    if (!emailInput || emailInput.dataset.focusAssist === 'true') return;

    emailInput.dataset.focusAssist = 'true';
    emailInput.addEventListener('pointerdown', () => {
      requestAnimationFrame(() => {
        if (document.activeElement !== emailInput) {
          emailInput.focus({ preventScroll: true });
        }
      });
    });
  };

  const enhanceNewsletterForm = (form) => {
    if (!form || form.dataset.ajaxEnhanced === 'true') return;

    const config = getFormConfig(form);
    if (!config) return;

    form.dataset.ajaxEnhanced = 'true';
    attachInputFocusAssist(form, config);
  };

  const getDirectFormChild = (node, form) => {
    let currentNode = node;

    while (currentNode && currentNode.parentElement && currentNode.parentElement !== form) {
      currentNode = currentNode.parentElement;
    }

    return currentNode && currentNode.parentElement === form ? currentNode : null;
  };

  const decorateShopifyInlineFormLayout = (shadowRoot) => {
    const form = shadowRoot.querySelector('form');
    if (!form) return false;

    form
      .querySelectorAll(
        '.mrstarsky-form-field, .mrstarsky-form-submit, .mrstarsky-form-consent, .mrstarsky-form-feedback',
      )
      .forEach((element) => {
        element.classList.remove(
          'mrstarsky-form-field',
          'mrstarsky-form-submit',
          'mrstarsky-form-consent',
          'mrstarsky-form-feedback',
        );
      });

    const handledGroups = new Set();
    form.querySelectorAll('input, select, textarea, button').forEach((control) => {
      if (control.tagName === 'BUTTON' && control.type !== 'submit') return;

      const group = getDirectFormChild(control, form);
      if (!group || handledGroups.has(group)) return;
      handledGroups.add(group);

      const type = (control.getAttribute('type') || '').toLowerCase();

      if (control.tagName === 'BUTTON' || type === 'submit') {
        group.classList.add('mrstarsky-form-submit');
        return;
      }

      if (type === 'checkbox' || type === 'radio') {
        group.classList.add('mrstarsky-form-consent');
        return;
      }

      group.classList.add('mrstarsky-form-field');
    });

    return true;
  };

  const injectShopifyInlineFormStyles = (shadowRoot) => {
    if (shadowRoot.getElementById(SHOPIFY_INLINE_FORM_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = SHOPIFY_INLINE_FORM_STYLE_ID;
    style.textContent = SHOPIFY_INLINE_FORM_SHADOW_CSS;
    shadowRoot.appendChild(style);
  };

  const styleShopifyInlineFormEmbed = (embed) => {
    if (!embed?.shadowRoot) return false;

    injectShopifyInlineFormStyles(embed.shadowRoot);
    return decorateShopifyInlineFormLayout(embed.shadowRoot);
  };

  const logLeadTracking = (message, details = {}) => {
    if (!new URLSearchParams(window.location.search).has('debug_lead_tracking')) return;
    console.info(`[lead] ${message}`, details);
  };

  const pushNewsletterLead = ({ target, email, formInstanceId = null, source }) => {
    if (!target || target.dataset.mrstarskyNewsletterEventPublished === 'true') return;

    const eventId =
      window.crypto?.randomUUID?.() ||
      `lead-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: SHOPIFY_FORMS_NEWSLETTER_EVENT,
      event_id: eventId,
      lead_email: email || undefined,
      form_instance_id: formInstanceId,
      source,
    });

    target.dataset.mrstarskyNewsletterEventPublished = 'true';
    logLeadTracking('dataLayer push sent', {
      event: SHOPIFY_FORMS_NEWSLETTER_EVENT,
      formInstanceId,
      hasLeadEmail: Boolean(email),
      source,
    });
  };

  const pushNewsletterSignupCompleted = (embed) => {
    pushNewsletterLead({
      target: embed,
      email: embed?.__mrstarskyNewsletterLeadEmail,
      formInstanceId: embed?.dataset.mrstarskyFormInstanceId || null,
      source: 'shopify_forms',
    });
  };

  const watchShopifyFormsNewsletterSuccess = (embed) => {
    if (!embed?.shadowRoot) return;
    if (embed.dataset.mrstarskyNewsletterSuccessObserved === 'true') return;

    embed.dataset.mrstarskyNewsletterSuccessObserved = 'true';

    const shadowRoot = embed.shadowRoot;
    let formWasRendered = false;
    let successObserver = null;

    const stopWatching = () => {
      successObserver?.disconnect();
      successObserver = null;
    };

    const checkForConfirmedSuccess = () => {
      const form = shadowRoot.querySelector('form[data-testid="form"]');
      const currentStep = shadowRoot.querySelector('[data-form-root][data-current-step]')?.getAttribute('data-current-step');

      if (form) {
        const formInstanceId = form.querySelector('shop-lead-capture[data-instance-id]')?.getAttribute('data-instance-id');
        if (!formInstanceId) return;

        formWasRendered = true;
        if (formInstanceId) embed.dataset.mrstarskyFormInstanceId = formInstanceId;

        if (embed.dataset.mrstarskyNewsletterWatcherAttached !== 'true') {
          embed.dataset.mrstarskyNewsletterWatcherAttached = 'true';
          logLeadTracking('watcher attached', { formInstanceId });
        }

        if (embed.dataset.mrstarskyLeadEmailCaptured !== 'true') {
          embed.dataset.mrstarskyLeadEmailCaptured = 'true';

          const captureLeadEmail = () => {
            const email = shadowRoot.querySelector('#email, [data-testid="field-email"]')?.value?.trim();
            if (email) embed.__mrstarskyNewsletterLeadEmail = email;
          };

          // Shopify Forms owns this shadow root. Capture the value while the
          // field exists rather than reading it after the success screen swaps it.
          ['input', 'change', 'submit'].forEach((eventName) => {
            shadowRoot.addEventListener(eventName, captureLeadEmail, true);
          });
          captureLeadEmail();
        }
        return;
      }

      // Shopify Forms changes this state only after the submission succeeds.
      // Validation failures retain the "form" step and therefore never push.
      if (formWasRendered && currentStep === 'success') {
        logLeadTracking('confirmed Shopify Forms success state', {
          formInstanceId: embed.dataset.mrstarskyFormInstanceId || null,
        });
        pushNewsletterSignupCompleted(embed);
        stopWatching();
      }
    };

    successObserver = new MutationObserver(checkForConfirmedSuccess);
    successObserver.observe(shadowRoot, {
      attributes: true,
      attributeFilter: ['data-current-step'],
      childList: true,
      subtree: true,
    });
    checkForConfirmedSuccess();
    window.setTimeout(stopWatching, SHOPIFY_FORMS_SUCCESS_WATCH_TIMEOUT);
  };

  const watchShopifyNewsletterSignupEmbed = (embed) => {
    if (!embed || embed.dataset.mrstarskyNewsletterEmbedObserved === 'true') return;
    if (!embed.closest(`[data-forms-id="${SHOPIFY_FORMS_NEWSLETTER_ROOT_ID}"]`)) return;

    embed.dataset.mrstarskyNewsletterEmbedObserved = 'true';

    let attempts = 0;
    const startWatching = () => {
      if (embed.shadowRoot) {
        logLeadTracking('shadow root available');
        watchShopifyFormsNewsletterSuccess(embed);
        return;
      }

      attempts += 1;
      if (attempts < SHOPIFY_FORMS_EMBED_WAIT_ATTEMPTS) {
        window.setTimeout(startWatching, SHOPIFY_FORMS_EMBED_WAIT_INTERVAL);
      } else {
        logLeadTracking('shadow root unavailable after timeout');
      }
    };

    startWatching();
  };

  const watchShopifyInlineFormEmbed = (embed) => {
    if (!embed || embed.dataset.mrstarskyObserved === 'true') return;

    embed.dataset.mrstarskyObserved = 'true';

    const run = () => {
      styleShopifyInlineFormEmbed(embed);

      if (embed.shadowRoot && !embed.__mrstarskyShadowObserver) {
        const shadowObserver = new MutationObserver(() => {
          styleShopifyInlineFormEmbed(embed);
        });

        shadowObserver.observe(embed.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
        });

        embed.__mrstarskyShadowObserver = shadowObserver;
      }
    };

    run();
    watchShopifyFormsNewsletterSuccess(embed);

    let attempts = 0;
    const retry = () => {
      run();
      attempts += 1;

      if ((!embed.shadowRoot || !embed.shadowRoot.querySelector('form')) && attempts < 120) {
        requestAnimationFrame(retry);
      }
    };

    requestAnimationFrame(retry);
  };

  const initShopifyInlineForms = (root = document) => {
    root.querySelectorAll(SHOPIFY_INLINE_FORM_SELECTOR).forEach((formRoot) => {
      formRoot.classList.add('mrstarsky-inline-form-root');
      formRoot.closest('.shopify-app-block')?.classList.add('mrstarsky-inline-form-block');
      formRoot.closest('.section[data-section-type="section-apps"]')?.classList.add('mrstarsky-inline-form-section');

      formRoot.querySelectorAll('shopify-forms-embed').forEach(watchShopifyInlineFormEmbed);
    });
  };

  const initShopifyNewsletterSignupTracking = (root = document) => {
    if (!root?.querySelectorAll) return;

    const embeds = [];

    if (root.matches?.('shopify-forms-embed')) embeds.push(root);
    embeds.push(...root.querySelectorAll('shopify-forms-embed'));

    embeds.forEach(watchShopifyNewsletterSignupEmbed);
  };

  const observeShopifyNewsletterEmbedInsertion = () => {
    const formRoot = document.querySelector(`[data-forms-id="${SHOPIFY_FORMS_NEWSLETTER_ROOT_ID}"]`);
    if (!formRoot || formRoot.dataset.mrstarskyNewsletterRootObserved === 'true') return;

    formRoot.dataset.mrstarskyNewsletterRootObserved = 'true';
    initShopifyNewsletterSignupTracking(formRoot);

    if (formRoot.querySelector('shopify-forms-embed')) return;

    const insertionObserver = new MutationObserver(() => {
      initShopifyNewsletterSignupTracking(formRoot);

      if (formRoot.querySelector('shopify-forms-embed')) {
        insertionObserver.disconnect();
      }
    });

    insertionObserver.observe(formRoot, { childList: true, subtree: true });
  };

  let trustpilotScriptPromise = null;
  let trustpilotObserver = null;

  const isTruthyFlag = (value) => value === true || value === 1 || value === '1' || value === 'true';

  const getTrustpilotWidgets = (root = document) =>
    Array.from(root.querySelectorAll(TRUSTPILOT_WIDGET_SELECTOR));

  const loadTrustpilotScript = () => {
    if (window.Trustpilot) {
      return Promise.resolve(window.Trustpilot);
    }

    if (trustpilotScriptPromise) {
      return trustpilotScriptPromise;
    }

    trustpilotScriptPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(TRUSTPILOT_SCRIPT_SELECTOR);

      const handleLoad = () => resolve(window.Trustpilot || null);
      const handleError = () => reject(new Error('trustpilot_script_failed'));

      if (existingScript) {
        existingScript.addEventListener('load', handleLoad, { once: true });
        existingScript.addEventListener('error', handleError, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = TRUSTPILOT_SCRIPT_URL;
      script.async = true;
      script.dataset.mrstarskyTrustpilotScript = 'true';
      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });
      document.head.appendChild(script);
    }).catch((error) => {
      trustpilotScriptPromise = null;
      throw error;
    });

    return trustpilotScriptPromise;
  };

  const hydrateTrustpilotWidgets = async (root = document) => {
    const widgets = getTrustpilotWidgets(root).filter((widget) => widget.dataset.mrstarskyTrustpilotLoaded !== 'true');
    if (!widgets.length) return;

    try {
      await loadTrustpilotScript();

      widgets.forEach((widget) => {
        if (window.Trustpilot?.loadFromElement) {
          window.Trustpilot.loadFromElement(widget);
        }

        widget.dataset.mrstarskyTrustpilotLoaded = 'true';
      });
    } catch (error) {
      // Fail silently so the rest of the page keeps working.
    }
  };

  const observeTrustpilotWidgets = (root = document) => {
    const widgets = getTrustpilotWidgets(root);
    if (!widgets.length) return;

    if (!('IntersectionObserver' in window)) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => hydrateTrustpilotWidgets(document), { timeout: 2500 });
      } else {
        window.setTimeout(() => hydrateTrustpilotWidgets(document), 1500);
      }
      return;
    }

    if (!trustpilotObserver) {
      trustpilotObserver = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          trustpilotObserver.disconnect();
          trustpilotObserver = null;
          hydrateTrustpilotWidgets(document);
        },
        {
          rootMargin: '300px 0px',
        },
      );
    }

    widgets.forEach((widget) => {
      if (widget.dataset.mrstarskyTrustpilotObserved === 'true') return;

      widget.dataset.mrstarskyTrustpilotObserved = 'true';
      trustpilotObserver.observe(widget);
    });
  };

  const shouldHideOrbeModal = () => {
    const currentCountry = String(window.mdApp_currentCountryCode || '').trim().toUpperCase();
    const redirectCountry = String(window.mdApp_redirectCountryCode || '').trim().toUpperCase();
    const redirectActive = isTruthyFlag(window.mdApp_redirectMode) || isTruthyFlag(window.mdApp_redirectRegionMode);

    if (!redirectActive) return true;
    if (!currentCountry || !redirectCountry) return true;

    return currentCountry === redirectCountry;
  };

  const applyOrbeMismatchGuard = () => {
    const modal = document.querySelector(ORBE_MODAL_SELECTOR);
    const embed = modal?.closest(ORBE_EMBED_SELECTOR) || document.querySelector(ORBE_EMBED_SELECTOR);
    const shouldHide = shouldHideOrbeModal();

    [embed, modal].filter(Boolean).forEach((element) => {
      if (shouldHide) {
        if (element.getAttribute(ORBE_FORCE_HIDE_ATTRIBUTE) !== 'true') {
          element.setAttribute(ORBE_FORCE_HIDE_ATTRIBUTE, 'true');
        }
        if (element.getAttribute('aria-hidden') !== 'true') {
          element.setAttribute('aria-hidden', 'true');
        }
      } else {
        if (element.hasAttribute(ORBE_FORCE_HIDE_ATTRIBUTE)) {
          element.removeAttribute(ORBE_FORCE_HIDE_ATTRIBUTE);
        }
      }
    });
  };

  const initOrbeMismatchGuard = () => {
    let attempts = 0;

    const watch = () => {
      applyOrbeMismatchGuard();
      attempts += 1;
      if (attempts < 80) {
        window.setTimeout(watch, 250);
      }
    };

    watch();
    window.addEventListener('pageshow', applyOrbeMismatchGuard);
    window.addEventListener('load', applyOrbeMismatchGuard, { once: true });
  };

  const handleNewsletterSubmit = async (event) => {
    const currentForm = event.target;
    if (!(currentForm instanceof HTMLFormElement)) return;

    if (currentForm.dataset.nativeSubmitting === 'true') return;

    const config = getFormConfig(currentForm);
    if (!config) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (currentForm.dataset.ajaxSubmitting === 'true') {
      return;
    }

    const targetSelector = config.replaceSelector || config.wrapperSelector;
    const wrapper = currentForm.closest(targetSelector);
    const submitButton = currentForm.querySelector('[type="submit"]');
    if (!wrapper) return;

    const action = new URL(currentForm.action || window.location.href, window.location.origin);
    action.hash = '';

    currentForm.dataset.ajaxSubmitting = 'true';
    currentForm.setAttribute('aria-busy', 'true');
    if (submitButton) submitButton.disabled = true;

    try {
      const response = await fetch(action.toString(), {
        method: currentForm.method || 'POST',
        body: new FormData(currentForm),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextWrapper = nextDocument.querySelector(targetSelector);

      if (!nextWrapper) {
        if (isChallengeResponse(nextDocument, html)) {
          throw new Error('challenge_required');
        }
        submitFormNatively(currentForm);
        return;
      }

      wrapper.innerHTML = nextWrapper.innerHTML;
      decorateFeedback(wrapper);
      setDynamicSectionState(wrapper.closest('.section-newsletter') || document);

      const successMessage = wrapper.querySelector(config.successSelector);
      const errors = wrapper.querySelector('.errors');

      if (successMessage) {
        const email = currentForm.querySelector(config.inputSelector || 'input[type="email"]')?.value?.trim();
        pushNewsletterLead({
          target: currentForm,
          email,
          source: currentForm.matches('.promo-pop__form-form') ? 'theme_newsletter_popup' : 'theme_newsletter',
        });
        setNewsletterSubscribedCookie();
        updateUrlForSuccess(config);
        scrollToSuccessTarget(currentForm, wrapper, config);
      }

      if (successMessage || errors) {
        const focusTarget = successMessage || errors;
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus();
      }

      wrapper.querySelectorAll('form').forEach(enhanceNewsletterForm);
    } catch (error) {
      const message =
        error instanceof Error && error.message === 'challenge_required'
          ? CHALLENGE_ERROR_MESSAGE
          : DEFAULT_ERROR_MESSAGE;
      showInlineError(wrapper, message);
    } finally {
      delete currentForm.dataset.ajaxSubmitting;
      currentForm.removeAttribute('aria-busy');
      if (submitButton) submitButton.disabled = false;
    }
  };

  const initNewsletterForms = (root = document) => {
    AJAX_NEWSLETTER_CONFIGS.forEach((config) => {
      root.querySelectorAll(config.formSelector).forEach(enhanceNewsletterForm);
    });

    decorateFeedback(root);
    setDynamicSectionState(root);
    syncSubscriptionCookieFromDOM(root);
  };

  initNewsletterForms();
  initShopifyInlineForms();
  initShopifyNewsletterSignupTracking();
  observeShopifyNewsletterEmbedInsertion();
  initLazyImageWakeups();
  observeTrustpilotWidgets();
  initOrbeMismatchGuard();

  document.addEventListener('shopify:section:load', (event) => {
    initNewsletterForms(event.target);
    initShopifyInlineForms(event.target);
    initShopifyNewsletterSignupTracking(event.target);
    observeShopifyNewsletterEmbedInsertion();
    scheduleLazyImageWake(event.target);
    observeTrustpilotWidgets(event.target);
  });

  document.addEventListener('submit', handleNewsletterSubmit, true);
})();
